import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
    Box, Typography, TextField, Button, Checkbox, FormControlLabel,
    Grid, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, IconButton, Autocomplete, Card, CardContent, Divider, MenuItem,
    Radio,
    Alert
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import Swal from 'sweetalert2';
import { db } from '../../firebase';
import { collection, addDoc, onSnapshot, query, where, updateDoc, doc, Timestamp, limit, getDocs, orderBy, writeBatch, getDoc, deleteDoc } from 'firebase/firestore';
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { uploadBytesResumable } from "firebase/storage";
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import MicIcon from '@mui/icons-material/Mic';
import { InputAdornment } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const WeighbridgeSoftware = () => {
    const Toast = Swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 4000, timerProgressBar: true, });
    const [isAuto, setIsAuto] = useState(true);
    const [liveWeight, setLiveWeight] = useState(0);
    const [manualWeight, setManualWeight] = useState(0);
    const [grossWeight, setGrossWeight] = useState(0);
    const [tareWeight, setTareWeight] = useState(0);
    const [netWeight, setNetWeight] = useState(0);
    const [grossDate, setGrossDate] = useState(null);
    const [tareDate, setTareDate] = useState(null);
    const [selectedTripId, setSelectedTripId] = useState(null);
    const [dailyCreditLimit, setdailyCreditLimit] = useState(0);
    const [monthcreditLimit, setmonthCreditLimit] = useState(0);
    const [remainingCredit, setRemainingCredit] = useState(0);
    const [usedCredit, setUsedCredit] = useState(0);
    const vehicleRef = useRef(null);
    const customerRef = useRef(null);
    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);
    const videoRef3 = useRef(null);
    const [isCaptured, setIsCaptured] = useState(false);
    const [weightType, setWeightType] = useState("tare"); // "tare" or "gross"
    const [whatsapp, setwhatsapp] = useState("Yes"); // "tare" or "gross"
    const [deleteOtp, setDeleteOtp] = useState("");
    const [generatedOtp, setGeneratedOtp] = useState("");
    const [otpDialogOpen, setOtpDialogOpen] = useState(false);
    const [deleteRowId, setDeleteRowId] = useState(null);
    const grossRadioRef = React.useRef(null);
    const tareRadioRef = React.useRef(null);
    const [resetKey, setResetKey] = useState(0);
    const [printData, setPrintData] = useState(null); // State to hold the trip data for printing
    const [pendingAutoAction, setPendingAutoAction] = useState("");
    const [throughDetails, setThroughDetails] = useState([]);

    const [autoOtpDialog, setAutoOtpDialog] = useState(false);
    const [autoOtp, setAutoOtp] = useState("");
    const [generatedAutoOtp, setGeneratedAutoOtp] = useState("");
    const [autoUnlocked, setAutoUnlocked] = useState(false);

    const [productRows, setProductRows] = useState([{ productId: '', productName: '', qty: "", rate: "", amount: 0 }]);
    const [openProductDialog, setOpenProductDialog] = useState(false);
    const [tempProduct, setTempProduct] = useState({ productId: "", productName: "", qty: "", rate: "", amount: 0 });

    const [payments, setPayments] = useState([
        {
            amount: "",
            paymentMode: "",
            note: "",
            date: new Date().toISOString().split("T")[0]
        },
        {
            amount: "",
            paymentMode: "",
            note: "",
            date: new Date().toISOString().split("T")[0]
        }
    ]);

    const handlePopupProduct = (value) => {
        if (!value) {
            setTempProduct(prev => ({
                ...prev,
                productId: "",
                productName: "",
                rate: 0,
                amount: 0
            }));
            return;
        }
        const { rate, product } = getCustomerOrProductRate(value, formData.customerId);
        const qty = parseFloat(tempProduct.qty) || 0;
        const extra = parseFloat(tempProduct.extraAmount) || 0;

        setTempProduct(prev => ({
            ...prev,
            productId: product?.id || "",
            productName: value,
            rate: rate,
            amount: Math.round((qty * rate) + extra)
        }));
    };


    const getCustomerOrProductRate = (prodName, custId) => {
        const prod = products.find(p => p.name === prodName);
        let finalRate = prod?.rate || 0;
        const currentCustId = custId || formData.customerId;
        if (currentCustId) {
            const selectedCust = customers.find(c => c.id === currentCustId);
            if (selectedCust && selectedCust.products && Array.isArray(selectedCust.products)) {
                const custProd = selectedCust.products.find(
                    p => (p.productName || p.name) === prodName
                );
                if (custProd && custProd.rate !== undefined && custProd.rate !== null && custProd.rate !== "") {
                    finalRate = Number(custProd.rate);
                }
            }
        }
        return { rate: finalRate, product: prod };
    };


    const handleTempChange = (field, value) => {
        setTempProduct(prev => {
            const newData = { ...prev, [field]: value };

            // Calculate base amount
            const qty = parseFloat(newData.qty) || 0;
            const rate = parseFloat(newData.rate) || 0;
            const extra = parseFloat(newData.extraAmount) || 0;

            // Total = (Qty * Rate) + Extra Charges
            newData.amount = (qty * rate) + extra;

            return newData;
        });
    };

    const addProductFromPopup = () => {
        if (!tempProduct.productName || tempProduct.qty <= 0) {
            Alert.alert("Error", "Please select a product and quantity");
            return;
        }

        const newRow = {
            productId: tempProduct.productId,
            productName: tempProduct.productName,
            qty: parseFloat(tempProduct.qty),
            rate: parseFloat(tempProduct.rate),
            extraLabel: tempProduct.extraLabel || "",
            extraAmount: parseFloat(tempProduct.extraAmount) || 0,
            amount: parseFloat(tempProduct.amount), // This is the final calculated amount
        };

        setProductRows([...productRows, newRow]);
        setOpenProductDialog(false);

        // Reset temp product
        setTempProduct({ qty: 0, rate: 0, amount: 0, extraAmount: 0, extraLabel: "" });
    };

    const handleProductChange = (index, value) => {
        const prod = products.find(p => p.name === value);
        let rate = 0;
        const selectedCustomer = customers.find(
            c => c.id === formData.customerId
        );

        if (selectedCustomer && selectedCustomer.products) {
            const custProd = selectedCustomer.products.find(
                p => p.productName === value
            );

            if (custProd) {
                rate = custProd.rate;
            } else {
                rate = prod?.rate || 0;
            }
        } else {
            rate = prod?.rate || 0;
        }

        const rows = [...productRows];
        rows[index].productId = prod?.id || '';
        rows[index].productName = value;
        rows[index].rate = rate;
        rows[index].amount = Math.round((rows[index].qty || 0) * rate);

        setProductRows(rows);

        setFormData(prev => ({
            ...prev,
            type: prod?.tripType || "Sale" // default Sale
        }));
    };



    const handleRowChange = (index, field, value) => {
        const rows = [...productRows];
        rows[index][field] = Number(value);
        const amount = rows[index].qty * rows[index].rate;
        rows[index].amount = Math.round(amount); // round figure
        setProductRows(rows);
    };

    const totalSale = productRows.reduce((sum, row) => sum + row.amount, 0);

    const [formData, setFormData] = useState({
        customerId: '',
        customerName: '',
        vehicleNo: '',
        challan: '',
        mobile: '',
        location: '',
        wbName: 'Matoshri Bridge',
        ticketNo: '',
        paymentMode: '',
        type: "Sale",
        invoice: "No",
        throughId: "",
        throughName: ""
    });

    const [customers, setCustomers] = useState([]);
    const [products, setProducts] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [paymentModes, setPaymentModes] = useState([]);
    const [pendingTransactions, setPendingTransactions] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [productList, setProductList] = useState([]); // all products
    const [customerProducts, setCustomerProducts] = useState([
        { productId: "", productName: "", rate: 0 }
    ]);

    const currentDisplayWeight = isAuto ? liveWeight : (manualWeight || 0);

    useEffect(() => {
        const q = query(
            collection(db, "customers"),
            orderBy("customerName", "asc") // "asc" for A-Z, "desc" for Z-A
        );

        onSnapshot(q, (s) => {
            const allData = s.docs.map(d => ({
                id: d.id,
                customerName: d.data().customerName?.trim().toUpperCase() || "", // Normalize to avoid "Rohan" vs "rohan"
                mobile: d.data().mobile || "",
                location: d.data().city || "",
                dailyCreditLimit: d.data().dailyCreditLimit,
                monthlyCreditLimit: d.data().monthlyCreditLimit,
                products: d.data().products || []
            }));

            // Filter for Unique Names only
            const uniqueCustomers = Array.from(
                new Map(allData.map(item => [item.customerName, item])).values()
            );

            setCustomers(uniqueCustomers);
        });
        onSnapshot(collection(db, "trip_products"), (s) => {
            setProducts(s.docs.map(d => ({
                id: d.id,
                name: d.data().productName,
                tripType: d.data().tripType,
                rate: d.data().rate || 0,

            })));
        });

        onSnapshot(collection(db, "vehicles"), (s) => {
            setVehicles(s.docs.map(d => d.data().vehicalNo || ""));
        });

        onSnapshot(collection(db, "payment_modes"), (s) => {
            setPaymentModes(s.docs.map(d => d.data().payMode || ""));
        });

        onSnapshot(collection(db, "throughdetails"), (snapshot) => {
            setThroughDetails(
                snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
            );
        });

    }, []);


    useEffect(() => {
        const q = query(
            collection(db, "trips"),
            where("status", "==", "Pending"),
            orderBy('createdAt', 'asc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(d => ({
                id: d.id,
                ...d.data()
            }));

            setPendingTransactions(data);
        });


        return () => unsubscribe();
    }, []);


    // ---------------- CALCULATIONS ----------------
    useEffect(() => {
        const net = Math.max(0, (grossWeight || 0) - (tareWeight || 0));
        setNetWeight(net);
    }, [grossWeight, tareWeight]);

    useEffect(() => {
        const qty = Number(formData.brass || 0);
        const rate = Number(formData.rate || 0);

        setFormData(prev => ({
            ...prev,
            amount: qty * rate
        }));

    }, [formData.brass, formData.rate]);

    useEffect(() => {
        if (window.electronAPI) {
            window.electronAPI.connectScale();
            window.electronAPI.onWeight((weight) => {
                console.log("Live Weight:", weight);
                setLiveWeight(weight);
            });
        }
    }, []);

    // const handleConnect = () => {
    //     if (window.electronAPI) {
    //         window.electronAPI.connectScale();
    //         window.electronAPI.onWeight((weight) => {
    //             console.log("Live Weight:", weight);
    //             setLiveWeight(weight);
    //         });
    //     }
    // };

    let port = null;
    let reader = null;
    let isReading = false;

    const handleConnect = async () => {
        try {
            if (isReading) {
                console.log("Already connected");
                return;
            }

            // ✅ 1. Get saved ports (avoid popup every time)
            const ports = await navigator.serial.getPorts();

            if (ports.length > 0) {
                port = ports[0];
            } else {
                port = await navigator.serial.requestPort();
            }

            // ✅ 2. Open port
            await port.open({
                baudRate: 2400,
                dataBits: 8,
                stopBits: 1,
                parity: "none",
                flowControl: "none"
            });

            console.log("Connected to port");

            // ✅ 3. Start reading
            isReading = true;
            readLoop();

        } catch (err) {
            console.error("Connection error:", err);
        }
    };

    const readLoop = async () => {
        const decoder = new TextDecoder();
        let buffer = "";

        try {
            reader = port.readable.getReader();

            while (true) {
                const { value, done } = await reader.read();

                if (done) break;

                if (value) {
                    buffer += decoder.decode(value, { stream: true });

                    let lines = buffer.split("\n");
                    buffer = lines.pop(); // keep incomplete line

                    for (let line of lines) {
                        const cleaned = line.replace(/[^\d.]/g, "").trim();

                        if (cleaned) {
                            const weight = Number(cleaned);
                            console.log("Weight:", weight);
                            setLiveWeight(weight);
                        }
                    }
                }
            }
        } catch (err) {
            console.error("Read error:", err);
        } finally {
            if (reader) {
                reader.releaseLock();
            }
            isReading = false;
        }
    };

    useEffect(() => {
        const handleDisconnectEvent = () => {
            console.log("Device disconnected");
            isReading = false;
        };

        navigator.serial.addEventListener("disconnect", handleDisconnectEvent);

        return () => {
            navigator.serial.removeEventListener("disconnect", handleDisconnectEvent);
        };
    }, []);


    const handleCapture = async () => {
        if (isCaptured) return;
        setIsCaptured(true);

        const currentWeight = isAuto ? liveWeight : manualWeight;

        if (!currentWeight || currentWeight <= 0) {
            Swal.fire("Error", "Weight not captured", "error");
            setIsCaptured(false);
            return;
        }

        try {
            // ================= TARE =================
            if (weightType === "tare") {

                setTareWeight(currentWeight);
                setTareDate(new Date());

                setFormData(prev => ({
                    ...prev,
                    tareWeight: currentWeight
                }));

                const photos = await Promise.all([
                    capturePhoto(videoRef1, "tare", 1),
                    capturePhoto(videoRef2, "tare", 2),
                    capturePhoto(videoRef3, "tare", 3),
                ]);

                const tarePhotoUrls = await savePhotos(photos);

                // Only update DB if trip already selected
                if (selectedTripId) {
                    const tripRef = doc(db, "trips", selectedTripId);
                    await updateDoc(tripRef, {
                        // tareWeight: currentWeight,
                        tarePhotos: tarePhotoUrls,
                        // tareDate: Timestamp.now()
                    });
                }

            }

            // ================= GROSS =================
            else if (weightType === "gross") {

                setGrossWeight(currentWeight);
                setGrossDate(new Date());

                setFormData(prev => ({
                    ...prev,
                    grossWeight: currentWeight
                }));

                const net = Math.max(0, currentWeight - (tareWeight || 0));
                setNetWeight(net);

                const photos = await Promise.all([
                    capturePhoto(videoRef1, "gross", 1),
                    capturePhoto(videoRef2, "gross", 2),
                    capturePhoto(videoRef3, "gross", 3),
                ]);

                const grossPhotoUrls = await savePhotos(photos);

                // Only update DB if trip exists
                if (selectedTripId) {
                    const tripRef = doc(db, "trips", selectedTripId);
                    await updateDoc(tripRef, {
                        // grossWeight: currentWeight,
                        grossPhotos: grossPhotoUrls,
                        // grossDate: Timestamp.now()
                    });
                }

                customerRef.current?.focus();
            }

        } catch (error) {
            console.error("Capture Error:", error);
            Swal.fire("Error", "Capture failed", "error");
        }

        setIsCaptured(false);
    };

    const handleProcess = async () => {
        try {
            if (!formData.vehicleNo) {
                return Swal.fire("Error", "Vehicle number required", "error");
            }

            if (!formData.customerName) {
                return Swal.fire("Error", "Customer name required", "error");
            }

            if (!formData.mobile) {
                return Swal.fire("Error", "Mobile No is  required", "error");
            }

            const weight = weightType === "tare" ? (formData.tareWeight) : (formData.grossWeight);

            if (!weight || weight <= 0) {
                return Swal.fire("Error", "Weight not captured", "error");
            }


            let tripId = selectedTripId;

            if (!tripId) {
                const existingPending = pendingTransactions.find(
                    t => t.vehicleNo === formData.vehicleNo && t.status === "Pending"
                );

                if (existingPending) {
                    return Swal.fire(
                        "Duplicate Entry",
                        `Vehicle ${formData.vehicleNo} already has a pending transaction (Ticket: ${existingPending.ticketNo}). Please complete that first.`,
                        "warning"
                    );

                    tripId = existingPending.id;
                    setSelectedTripId(existingPending.id);
                }
            }
            // const [customer, vehicleId] = await Promise.all([
            //     getOrCreateCustomer(formData),
            //     // getOrCreateVehicle(formData.vehicleNo)
            // ]);

            const [customer] = await Promise.all([
                getOrCreateCustomer(formData)
            ]);


            const now = Timestamp.now();

            const baseData = {
                ...formData,
                customerId: customer.id,
                customerName: customer.data.customerName,
                vehicleId: formData.vehicleNo,
                products: productRows,
                totalAmount: totalSale,
                throughId: formData.throughId || "",
                throughName: formData.throughName || "",
            };

            if (!tripId) {
                const nextTicket = await generateTicketNo();
                let newData = {
                    ...baseData,
                    ticketNo: nextTicket,
                    status: "Pending",
                    createdAt: Timestamp.now(),
                };

                if (weightType === "tare") {
                    newData.tareWeight = weight;
                    newData.tareDate = now;
                } else {
                    newData.grossWeight = weight;
                    newData.grossDate = now;
                }

                const tripRef = await addDoc(collection(db, "trips"), newData);

                // const photosPromise = captureAllPhotos(tripRef.id, weightType);
                // updatedData[weightType + "Photos"] = await photosPromise;

                const photos = await captureAllPhotos(tripRef.id, weightType);
                await updateDoc(tripRef, {
                    [weightType + "Photos"]: photos
                });

                Swal.fire("Success", `${weightType.toUpperCase()} saved as Pending`, "success");
                playSuccessSound();
                clearForm();
                setIsCaptured(false);
                setResetKey(prev => prev + 1);
                return;
            }
            const tripRef = doc(db, "trips", tripId);
            // const tripSnap = await getDoc(tripRef);
            // const tripData = tripSnap.data();
            const tripData = pendingTransactions.find(t => t.id === tripId) || {};

            let updatedData = {};
            if (weightType === "tare") {
                updatedData.tareWeight = weight;
                updatedData.tareDate = now;
            } else {
                updatedData.grossWeight = weight;
                updatedData.grossDate = now;
            }

            // const photos = await captureAllPhotos(tripId, weightType);
            // updatedData[weightType + "Photos"] = photos;

            const photosPromise = captureAllPhotos(tripId, weightType);
            updatedData[weightType + "Photos"] = await photosPromise;

            let finalTare = updatedData.tareWeight || tripData.tareWeight || 0;
            let finalGross = updatedData.grossWeight || tripData.grossWeight || 0;

            if (finalTare > 0 && finalGross > 0 && finalTare > finalGross) {
                const result = await Swal.fire({
                    title: "Weight Mismatch",
                    text: `Tare (${finalTare}) is higher than Gross (${finalGross}). Swap them?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Swap & Save",
                });

                if (result.isConfirmed) {
                    // Perform the swap in local variables
                    const tempWeight = finalTare;
                    finalTare = finalGross;
                    finalGross = tempWeight;

                    // CRITICAL: Update the object that actually gets sent to Firestore
                    updatedData.tareWeight = finalTare;
                    updatedData.grossWeight = finalGross;

                    // Swap the dates in the update object as well
                    const tempDate = updatedData.tareDate || tripData.tareDate;
                    updatedData.tareDate = updatedData.grossDate || tripData.grossDate;
                    updatedData.grossDate = tempDate;
                } else {
                    setIsCaptured(false);
                    return;
                }
            }

            if (finalTare > 0 && finalGross > 0) {

                const net = Math.max(0, finalGross - finalTare);
                await checkVehicleWeightAlert(formData.vehicleNo, net);

                const paid = payments.reduce(
                    (sum, p) => sum + Number(p.amount || 0),
                    0
                );
                const remaining = totalSale - paid;
                const oldPayments = tripData?.payments || [];

                const newPaymentEntries = payments
                    .filter(p => Number(p.amount) > 0)
                    .map(p => ({
                        amount: Number(p.amount),
                        mode: p.paymentMode || "Cash",
                        note: p.note || "",
                        date: Timestamp.fromDate(new Date(p.date)),
                        createdAt: Timestamp.now()
                    }));

                updatedData = {
                    ...baseData,
                    ...updatedData,
                    netWeight: net,
                    paidAmount: paid,
                    remainingAmount: remaining,
                    payments:
                        newPaymentEntries.length > 0
                            ? [...oldPayments, ...newPaymentEntries]
                            : oldPayments,
                    status: "Completed",
                };

                await updateDoc(tripRef, updatedData);

                if (paid > 0) {
                    for (const payment of newPaymentEntries) {
                        await addDoc(collection(db, "customer_history"), {
                            customerId: customer.id,
                            amount: payment.amount,
                            paymentMode: payment.mode,
                            note: payment.note,
                            date: payment.date,
                            tripId: tripId,
                            type: "Trip",
                            createdAt: Timestamp.now()
                        });
                    }
                }

                // ================= WHATSAPP + PDF =================
                try {
                    const invoiceData = {
                        customerName: formData.customerName,
                        mobile: formData.mobile,
                        vehicleNo: formData.vehicleNo,
                        ticketNo: tripData.ticketNo,
                        challan: formData.challan,
                        products: productRows
                    };

                    setTimeout(async () => {
                        try {
                            const pdfBlob = await pdf(<InvoicePDF invoiceData={invoiceData} />).toBlob();

                            const storageRef = ref(storage, `invoices/invoice_${Date.now()}.pdf`);
                            const snapshot = await uploadBytes(storageRef, pdfBlob);

                            const downloadURL = await getDownloadURL(snapshot.ref);
                            const creditData = await calculateCustomerCreditLive(customer.id, customer.data);
                            const mobile = formData.mobile?.trim();

                            if (mobile !== "0000000000") {
                                await sendWhatsAppMessage(
                                    mobile,
                                    downloadURL,
                                    formData.customerName,
                                    tripData.ticketNo,
                                    totalSale,
                                    productRows,
                                    creditData.totalRemaining,
                                    formData.vehicleNo,
                                );
                            }
                        } catch (err) {
                            console.error("Background task error:", err);
                        }
                    }, 0);

                    // const pdfBlob = await pdf(
                    //     <InvoicePDF invoiceData={invoiceData} />
                    // ).toBlob();

                    // const storageRef = ref(storage, `invoices/invoice_${Date.now()}.pdf`);
                    // const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

                    // uploadTask.on(
                    //     "state_changed",
                    //     null,
                    //     (error) => console.error(error),
                    //     async () => {

                    //         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    //         const creditData = await calculateCustomerCreditLive(customer.id, customer.data);

                    //         await sendWhatsAppMessage(
                    //             formData.mobile,
                    //             downloadURL,
                    //             formData.customerName,
                    //             tripData.ticketNo,
                    //             totalSale,
                    //             productRows,
                    //             creditData.remaining || 0,
                    //             formData.vehicleNo,
                    //         );
                    //     }
                    // );

                } catch (error) {
                    console.error("PDF Error:", error);
                }

                Swal.fire("Completed", "Transaction Completed Successfully", "success");
                playSuccessSound();

                setdailyCreditLimit(0);
                setmonthCreditLimit(0);
                setRemainingCredit(0);
                setUsedCredit(0);
                setResetKey(prev => prev + 1);
                clearForm();
            }
            else {
                // ================= STILL PENDING =================
                updatedData.status = "Pending";

                await updateDoc(tripRef, updatedData);

                Swal.fire("Pending", "Saved. Waiting for other weight", "info");
            }

            setIsCaptured(false);

        } catch (e) {
            setIsCaptured(false);
            Swal.fire("Error", "Transaction failed: " + e.message, "error");
        }
    };


    const playSuccessSound = () => {
        const audio = new Audio("/preview.mp3");
        audio.play().catch(err => console.log("Audio play blocked:", err));
    };

    const handleDeleteProduct = (indexToDelete) => {
        if (productRows.length === 1) {
            setProductRows([{ productId: '', productName: '', qty: "", rate: "", amount: 0 }]);
            return;
        }

        setProductRows(prev => prev.filter((_, idx) => idx !== indexToDelete));
    };

    const calculateCustomerCreditLive = async (custId, customerData = {}) => {
        try {
            // 1. Fetch all Trips (Sales)
            const tripQuery = query(
                collection(db, "trips"),
                where("customerId", "==", custId)
            );
            const tripSnap = await getDocs(tripQuery);

            // 2. Fetch all Payments (Receipts)
            const paymentQuery = query(
                collection(db, "customer_history"),
                where("customerId", "==", custId)
            );
            const paymentSnap = await getDocs(paymentQuery);

            let totalSale = 0;
            let totalPaid = 0;

            // Sum up all Sales from trips
            tripSnap.forEach(doc => {
                const data = doc.data();
                totalSale += Number(data.totalAmount || 0);
            });

            // Sum up all Payments from history
            paymentSnap.forEach(doc => {
                const data = doc.data();
                totalPaid += Number(data.amount || 0);
            });

            // Calculation
            const totalRemaining = totalSale - totalPaid;

            // Limits (checking daily/monthly used based on remaining amounts)
            const dailyLimit = Number(customerData.dailydailyCreditLimit || 0);
            const monthlyLimit = Number(customerData.monthlydailyCreditLimit || 0);

            return {
                totalSale,
                totalPaid,
                totalRemaining, // <--- This is your Net Balance
                dailyRemaining: dailyLimit - totalRemaining, // Optional: relative to limit
                isExceeded: totalRemaining > dailyLimit && dailyLimit > 0
            };

        } catch (err) {
            console.error("Credit calc error:", err);
            return { totalSale: 0, totalPaid: 0, totalRemaining: 0 };
        }
    };

    const getOrCreateVehicle = async (vehicleNo) => {
        const vehicleRef = collection(db, "vehicles");

        const q = query(vehicleRef, where("vehicalNo", "==", vehicleNo));
        const snap = await getDocs(q);

        if (!snap.empty) {
            return snap.docs[0].id;
        }

        // ❌ Not found → create new vehicle
        const newVehicle = {
            type: "Tipper",
            vehicalNo: vehicleNo,
            puc: "",
            insurance: "",
            pucDate: "",
            insuranceDate: "",
            createdAt: Timestamp.now(),
        };

        const docRef = await addDoc(vehicleRef, newVehicle);

        return docRef.id;
    };


    const fetchProductDetails = async (productId) => {
        const q = query(
            collection(db, "tripProducts"),
            where("__name__", "==", productId)
        );

        const snap = await getDocs(q);

        if (!snap.empty) {
            return snap.docs[0].data();
        }

        return null;
    };

    const getOrCreateCustomer = async (formData) => {
        console.log(formData);

        const customersRef = collection(db, "customers");

        let q;

        if (formData.mobile) {
            q = query(customersRef, where("mobile", "==", formData.mobile));
        } else {
            q = query(customersRef, where("customerName", "==", formData.customerName));
        }

        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
            const docSnap = snapshot.docs[0];
            return { id: docSnap.id, data: docSnap.data() };
        }

        // CREATE NEW
        const newCustomer = {
            customerName: formData.customerName || "",
            mobile: formData.mobile || "",
            address: formData.location || "",
            city: formData.location || "",
            createdAt: Timestamp.now(),
        };

        const docRef = await addDoc(customersRef, newCustomer);
        handlePartySelect(newCustomer);
        return { id: docRef.id, data: newCustomer };
    };

    const handlePartySelect = async (cust) => {
        if (!cust) return;

        setFormData(prev => ({
            ...prev,
            customerId: cust.id,
            customerName: cust.customerName,
            mobile: cust.mobile,
            location: cust.location
        }));

        setdailyCreditLimit(cust.dailyCreditLimit || 0);
        setmonthCreditLimit(cust.monthlyCreditLimit || 0);

        // ✅ FIX: pass full object
        calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
    };

    const calculateCustomerCredit = async (custId, limit) => {

        const now = new Date();
        const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // 2. Query trips for this customer created today
        const tripQuery = query(
            collection(db, "trips"),
            where("customerId", "==", custId),
            where("grossDate", ">=", startOfToday) // Adjust "tareDate" to your actual field name
        );

        const tripSnap = await getDocs(tripQuery);
        let totalSale = 0;

        tripSnap.forEach(doc => {
            const data = doc.data();
            const tripTotal = data.products?.reduce(
                (sum, p) => sum + Number(p.amount || 0),
                0
            ) || 0;

            totalSale += tripTotal;
        });

        // GET PAYMENTS
        const payQuery = query(
            collection(db, "customer_history"),
            where("customerId", "==", custId)
        );

        const paySnap = await getDocs(payQuery);
        let totalPaid = 0;
        paySnap.forEach(doc => {

            const data = doc.data();

            totalPaid += Number(data.amount || 0);

        });

        const used = totalSale - totalPaid;
        const remaining = limit - used;

        // ================= ALERT =================
        if (remaining < dailyCreditLimit) {
            Swal.fire({
                title: "🚫 Credit Limit Exceeded",
                html: `
                    <b style="color:red">Limit Exceeded!</b><br/><br/>
                `,
                icon: "error"
            });
        }

        setUsedCredit(used);
        setRemainingCredit(remaining);
    };


    const clearForm = () => {
        setIsCaptured(false);

        setFormData({
            customerId: "",
            customerName: "",
            vehicleNo: "",
            challan: "",
            mobile: "",
            location: "",
            wbName: "Matoshri Bridge",
            ticketNo: "",
            paymentMode: "",
            throughId: "",
            throughName: ""
        });

        setResetKey(prev => prev + 1);

        setProductRows([
            { productId: "", productName: "", qty: 0, rate: 0, amount: 0 }
        ]);

        setGrossWeight(0);
        setTareWeight(0);
        setNetWeight(0);

        setGrossDate(null);
        setTareDate(null);

        setSelectedTripId(null);
        setManualWeight(0);

        setPayments([
            {
                amount: "",
                paymentMode: "",
                note: "",
                date: new Date().toISOString().split("T")[0]
            },
            {
                amount: "",
                paymentMode: "",
                note: "",
                date: new Date().toISOString().split("T")[0]
            }
        ]);
    };

    const formatDate = (d) => {
        if (!d) return "N/A";
        const date = new Date(d);

        // Returns: 01/04/26, 7:55 PM
        return date.toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    useEffect(() => {
        const fetchLastTicket = async () => {
            try {
                const q = query(
                    collection(db, "trips"),
                    orderBy("ticketNo", "desc"),
                    limit(1)
                );

                const snap = await getDocs(q);

                let nextTicketNo = 1; // Default if collection is empty

                if (!snap.empty) {
                    const lastTicket = snap.docs[0].data().ticketNo || 0;
                    nextTicketNo = lastTicket + 1;
                }


                // Updating the formData state
                setFormData((prev) => ({
                    ...prev,
                    ticketNo: nextTicketNo
                }));

            } catch (error) {
                console.error("Error fetching last ticket number:", error);
            }
        };

        fetchLastTicket();
    }, []); // Empty dependency array ensures this runs once on mount

    const generateTicketNo = async () => {

        const q = query(
            collection(db, "trips"),
            orderBy("ticketNo", "desc"),
            limit(1)
        );

        const snap = await getDocs(q);

        if (snap.empty) {
            return 1;
        }

        const lastTicket = snap.docs[0].data().ticketNo || 0;

        return lastTicket + 1;
    };

    const startCameras = async () => {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const cameras = devices.filter(d => d.kind === "videoinput");

        if (cameras.length === 0) {
            alert("No cameras found!");
            return;
        }

        if (cameras[0]) {
            const stream1 = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameras[0].deviceId } });
            videoRef1.current.srcObject = stream1;
        }

        if (cameras[1]) {
            const stream2 = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameras[1].deviceId } });
            videoRef2.current.srcObject = stream2;
        }

        if (cameras[2]) {
            const stream3 = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameras[2].deviceId } });
            videoRef3.current.srcObject = stream3;
        }
    };

    useEffect(() => {
        startCameras();

        return () => {
            [videoRef1, videoRef2, videoRef3].forEach(ref => {
                const stream = ref.current?.srcObject;
                if (stream) {
                    stream.getTracks().forEach(track => track.stop());
                }
            });
        };
    }, []);

    const handleVoiceInput = () => {
        // 1. Compatibility Check
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!SpeechRecognition) {
            return Swal.fire("Error", "Speech recognition is not available in this browser/version.", "error");
        }

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN'; // Use 'mr-IN' for Marathi
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => {
            // Optional: Change Mic icon color to red here to show recording
            console.log("Voice typing started...");
        };

        recognition.onresult = (event) => {
            let transcript = event.results[0][0].transcript.trim().toUpperCase();

            if (transcript.endsWith('.')) {
                transcript = transcript.slice(0, -1);
            }

            // Update local state
            setFormData(prev => ({ ...prev, customerName: transcript }));

            // Auto-Match with existing list
            const matchedCustomer = customerOptions.find(
                c => c.customerName.toUpperCase() === transcript
            );

            if (matchedCustomer) {
                handlePartySelect(matchedCustomer);
            }
        };

        recognition.onerror = (event) => {
            console.error("Speech Error:", event.error);
            if (event.error === 'not-allowed') {
                Swal.fire("Permission Denied", "Electron blocked microphone access. Check main.js handlers.", "error");
            } else if (event.error === 'no-speech') {
                // Silently handle if user didn't say anything
            }
        };

        try {
            recognition.start();
        } catch (err) {
            console.error("Recognition start failed:", err);
        }
    };
    const capturePhoto = async (videoRef, type, cameraIndex) => {
        if (!videoRef.current) return null;

        const canvas = document.createElement("canvas");
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        const blob = await new Promise(resolve =>
            canvas.toBlob(resolve, "image/jpeg", 0.9)
        );

        return { blob, fileName: `${type}_cam${cameraIndex}_${Date.now()}.jpg` };
    };


    const captureAllPhotos = async (tripId, type) => {
        // Capture all blobs first
        const blobs = await Promise.all([
            capturePhoto(videoRef1, type, 1),
            capturePhoto(videoRef2, type, 2),
            capturePhoto(videoRef3, type, 3),
        ]);

        // Upload all in parallel
        const uploadPromises = blobs.map((photo, index) => {
            if (!photo) return null;
            const storageRef = ref(storage, `trips/${tripId}/${photo.fileName}`);
            return uploadBytes(storageRef, photo.blob).then(() => getDownloadURL(storageRef));
        });

        const urls = await Promise.all(uploadPromises);

        return urls.filter(u => u !== null); // Remove any nulls
    };

    const savePhotos = async (photos) => {
        const urls = [];
        for (const photo of photos) {
            if (!photo) continue;
            const storageRef = ref(storage, `weighbridge/${photo.fileName}`);
            await uploadBytes(storageRef, photo.blob);
            const url = await getDownloadURL(storageRef);
            urls.push(url);
        }
        return urls;
    };

    const fetchCustomerFromVehicle = async (vehicleNo) => {
        try {
            // 🔥 1. Check in pending transactions FIRST
            const normalize = (v) => v?.replace(/\s+/g, "").toUpperCase();

            const pendingTrip = pendingTransactions.find(
                t =>
                    normalize(t.vehicleNo) === normalize(vehicleNo) &&
                    t.status === "Pending"
            );

            if (pendingTrip) {
                console.log("Found in pending:", pendingTrip);

                // ✅ Directly fill form
                setSelectedTripId(pendingTrip.id);

                setFormData(prev => ({
                    ...prev,
                    customerId: pendingTrip.customerId || "",
                    customerName: pendingTrip.customerName || "",
                    vehicleNo: pendingTrip.vehicleNo || "",
                    mobile: pendingTrip.mobile || "",
                    location: pendingTrip.location || "",
                    challan: pendingTrip.challan || "",
                    ticketNo: pendingTrip.ticketNo || "",
                }));

                // ✅ Products
                setProductRows(
                    pendingTrip.products?.length > 0
                        ? pendingTrip.products
                        : [{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]
                );

                // ✅ Tare
                setTareWeight(pendingTrip.tareWeight || 0);
                setTareDate(
                    pendingTrip.tareDate ? pendingTrip.tareDate.toDate() : null
                );

                // ✅ Credit
                if (pendingTrip.customerId) {
                    const cust = customers.find(c => c.id === pendingTrip.customerId);

                    if (cust) {
                        setdailyCreditLimit(cust.dailyCreditLimit || 0);
                        setmonthCreditLimit(cust.monthlyCreditLimit || 0);
                        calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
                    }
                }

                return; // 🚀 STOP here (no Firestore call)
            }

            // 🔥 2. ELSE → fallback to Firestore (your existing logic)
            const q = query(
                collection(db, "trips"),
                where("vehicleNo", "==", vehicleNo),
                where("customerId", "!=", ""),
                orderBy("tareDate", "desc"),
                limit(1)
            );

            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const data = snapshot.docs[0].data();

                setFormData(prev => ({
                    ...prev,
                    customerId: data.customerId || "",
                    customerName: data.customerName || "",
                    mobile: data.mobile || "",
                    location: data.location || ""
                }));

                if (data.customerId) {
                    const cust = customers.find(c => c.id === data.customerId);

                    if (cust) {
                        setdailyCreditLimit(cust.dailyCreditLimit || 0);
                        setmonthCreditLimit(cust.monthlyCreditLimit || 0);
                        calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
                    }
                }
            } else {
                console.log("No previous trip found for this vehicle");
            }

        } catch (err) {
            console.log("Error fetching vehicle data:", err);
        }
    };

    const checkVehicleWeightAlert = async (vehicleNo, currentNetWeight) => {
        try {
            const q = query(
                collection(db, "trips"),
                where("vehicleNo", "==", vehicleNo),
                orderBy("tareDate", "desc"),
                limit(6)
            );

            const snap = await getDocs(q);

            if (snap.empty) return;

            const weights = snap.docs.map(d => {
                const data = d.data();
                return Number(data.netWeight || 0);
            });

            console.log("Last Weights:", weights);

            // ==============================
            // 🚨 CASE 1: LESS THAN 3 TRIPS
            // ==============================
            if (weights.length < 2) {

                await addDoc(collection(db, "weight_alerts"), {
                    vehicleNo,
                    previousWeights: weights,
                    currentWeight: currentNetWeight,
                    type: "NEW_VEHICLE_ALERT",
                    reason: "Less than 3 trips data",
                    createdAt: Timestamp.now(),
                    status: 'Unread',
                });

                // Toast.fire({
                //     icon: "warning",
                //     title: `⚠️ ${vehicleNo} | New Vehicle / Low History`
                // });

                return;
            }

            // ==============================
            // 🚨 CASE 2: NORMAL HIGH CHECK
            // ==============================

            const avgWeight =
                weights.reduce((sum, w) => sum + w, 0) / weights.length;

            const MAX_ALLOWED_DIFF = 500;

            if (currentNetWeight > avgWeight + MAX_ALLOWED_DIFF) {

                const diff = currentNetWeight - avgWeight;

                await addDoc(collection(db, "weight_alerts"), {
                    vehicleNo,
                    previousWeights: weights,
                    averageWeight: avgWeight,
                    currentWeight: currentNetWeight,
                    difference: diff,
                    type: "HIGH_ALERT 🚨",
                    createdAt: Timestamp.now(),
                    status: 'Unread',

                });

                Toast.fire({
                    icon: "error",
                    title: `🚨 ${vehicleNo} | ${currentNetWeight} kg (+${diff.toFixed(0)})`
                });
            }

        } catch (err) {
            console.log("Weight Alert Error:", err);
        }
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };


    const sendWhatsAppMessage = async (
        mobile,
        downloadURL,
        customerName,
        invoiceNo,
        amount,
        products = [],
        outstanding = 0,
        vehicalNo
    ) => {
        try {
            const phoneid = "1092943420558604";
            const accesstoken = "EAAKj5T0Mx1YBRNd6VhhufPP2ApIjZCsZBFOkl855np9VZBvPvZAZAj7axVAevZBiapxd1Iw38v0hhZBwB2knNeLYSVgjR3RqtPn164H2GQ3ljP46kQvAAq0gsl3lfKDh55ZCsmo5fGZCaUSPpCRqeFjVA6VUeIaiu0ZCNxPPMTsV4oxnnUz4TRoICdbiW0xsAncwZDZD";

            // ✅ Extract values from products
            const productNames = products
                .map((p, i) => `${i + 1}) ${p.productName}`)
                .join(" / ");

            const qtyList = products
                .map((p, i) => `${i + 1}) ${p.qty}`)
                .join(" / ");


            const todayDate = new Date().toLocaleDateString("en-IN");

            const payload = {
                messaging_product: "whatsapp",
                to: "91" + mobile,
                type: "template",
                template: {
                    name: "trip_invoice",
                    language: { code: "en" },
                    components: [
                        {
                            type: "header",
                            parameters: [
                                {
                                    type: "document",
                                    document: {
                                        link: downloadURL,
                                        filename: "Invoice.pdf"
                                    }
                                }
                            ]
                        },
                        {
                            type: "body",
                            parameters: [
                                { type: "text", text: customerName },                 // {{1}}
                                { type: "text", text: productNames || "-" },          // {{2}}
                                { type: "text", text: qtyList.toString() },          // {{3}}
                                { type: "text", text: amount.toString() },            // {{5}}
                                { type: "text", text: todayDate },                    // {{6}}
                                { type: "text", text: vehicalNo.toString() },     // {{7}}
                                { type: "text", text: outstanding.toString() },     // {{7}}
                            ]
                        }
                    ]
                }
            };

            const response = await fetch(`https://graph.facebook.com/v22.0/${phoneid}/messages`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`
                },
                body: JSON.stringify(payload)
            });


            const data = await response.json();
            if (response.ok) {
                console.log("✅ WhatsApp Sent:", data);
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, customerName, invoiceNo, type: "Trip Invoice", amount, fileURL: downloadURL, status: "Sent", createdAt: Timestamp.now() });
                Toast.fire({ icon: "success", title: "WhatsApp Invoice Sent" });
            }
            else {
                console.error("❌ WhatsApp Error:", data);
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, customerName, invoiceNo, type: "Trip Invoice", amount, fileURL: downloadURL, status: "Failed", error: data.error?.message, createdAt: Timestamp.now() });
            }



        } catch (error) {
            console.error("❌ Fetch Error:", error);
        }
    };

    const InvoicePDF = ({ invoiceData }) => {

        const products = invoiceData.products || [];

        const totalSale = products.reduce(
            (sum, item) => sum + Number(item.amount || 0),
            0
        );

        return (
            <Document>
                <Page size="A4" style={styles.page}>

                    {/* HEADER */}
                    <View style={styles.headerBox}>
                        <Text style={styles.company}>MATOSHRI INFRA DHARASHIV PVT LTD</Text>
                        <Text style={styles.sub}>Dharashiv, Maharashtra</Text>
                        <Text style={styles.sub}> +91 75076 01020</Text>
                    </View>

                    {/* INVOICE TITLE */}
                    <View style={styles.invoiceTitleBox}>
                        <Text style={styles.invoiceTitle}>TRIP INVOICE</Text>
                    </View>

                    {/* DETAILS */}
                    <View style={styles.detailsWrapper}>

                        <View style={styles.detailsCard}>
                            <Text style={styles.cardTitle}>Customer Details</Text>

                            <View style={styles.row}>
                                <Text style={styles.label}>Name</Text>
                                <Text style={styles.value}>{invoiceData.customerName || "-"}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Mobile</Text>
                                <Text style={styles.value}>{invoiceData.mobile || "-"}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Vehicle</Text>
                                <Text style={styles.value}>{invoiceData.vehicleNo || "-"}</Text>
                            </View>
                        </View>

                        <View style={styles.detailsCard}>
                            <Text style={styles.cardTitle}>Trip Details</Text>

                            <View style={styles.row}>
                                <Text style={styles.label}>Ticket No</Text>
                                <Text style={styles.value}>{invoiceData.ticketNo}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Chalan No</Text>
                                <Text style={styles.value}>{invoiceData.challan || "-"}</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Date</Text>
                                <Text style={styles.value}>
                                    {new Date().toLocaleDateString()}
                                </Text>
                            </View>
                        </View>

                    </View>

                    {/* TABLE */}
                    <View style={styles.tableBox}>

                        <View style={styles.tableHeader}>
                            <Text style={{ width: '10%' }}>#</Text>
                            <Text style={{ width: '35%' }}>Product</Text>
                            <Text style={{ width: '15%', textAlign: 'right' }}>Qty</Text>
                            <Text style={{ width: '20%', textAlign: 'right' }}>Rate</Text>
                            <Text style={{ width: '20%', textAlign: 'right' }}>Amount</Text>
                        </View>

                        {products.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <Text style={{ width: '10%' }}>{index + 1}</Text>
                                <Text style={{ width: '35%' }}>{item.productName}</Text>
                                <Text style={{ width: '15%', textAlign: 'right' }}>{item.qty}</Text>
                                <Text style={{ width: '20%', textAlign: 'right' }}>{item.rate}</Text>
                                <Text style={{ width: '20%', textAlign: 'right' }}>{item.amount}</Text>
                            </View>
                        ))}

                    </View>

                    {/* TOTAL */}
                    <View style={styles.totalSection}>
                        <Text style={styles.totalLabel}>TOTAL SALE</Text>
                        <Text style={styles.totalValue}> {totalSale.toFixed(2)}</Text>
                    </View>


                    {/* FOOTER */}
                    <View style={styles.footerBox}>
                        <Text style={styles.footer}>Thank you for your business </Text>
                    </View>

                </Page>
            </Document>
        );
    };


    const fetchTripByTicket = async (ticketNo) => {
        try {
            if (!ticketNo) return;

            const q = query(
                collection(db, "trips"),
                where("ticketNo", "==", Number(ticketNo)) // ✅ FIX
            );

            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                Swal.fire("Not Found", "No trip found for this ticket", "warning");
                return;
            }

            const docSnap = snapshot.docs[0];

            const row = { id: docSnap.id, ...docSnap.data() };

            console.log("Trip found:", row);

            // ✅ SAME LOGIC AS YOUR onClick
            setSelectedTripId(row.id);

            setFormData({
                customerId: row.customerId || "",
                customerName: row.customerName || "",
                vehicleNo: row.vehicleNo || "",
                product: row.product || "",
                challan: row.challan || "",
                brass: row.brass || "",
                rate: row.rate || 0,
                amount: row.amount || 0,
                mobile: row.mobile || "",
                location: row.location || "",
                wbName: row.wbName || "Matoshri Bridge",
                ticketNo: row.ticketNo || "",
                paymentMode: row.paymentMode || ""
            });

            // ✅ Credit
            if (row.customerId) {
                const cust = customers.find(c => c.id === row.customerId);

                if (cust) {
                    setdailyCreditLimit(cust.dailyCreditLimit || 0);
                    setmonthCreditLimit(cust.monthlyCreditLimit || 0);
                    calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
                } else {
                    calculateCustomerCredit(row.customerId, 0);
                }
            }

            // ✅ Products
            setProductRows(
                row.products?.length > 0
                    ? row.products
                    : [{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]
            );

            // ✅ Weight
            setTareWeight(row.tareWeight || 0);
            setTareDate(row.tareDate ? row.tareDate.toDate() : null);

            // ✅ Payment
            setPayments(
                row.payments && row.payments.length > 0
                    ? row.payments.map(payment => ({
                        amount: payment.amount || "",
                        paymentMode: payment.mode || "",
                        note: payment.note || "",
                        date: payment.date
                            ? new Date(payment.date.seconds * 1000)
                                .toISOString()
                                .split("T")[0]
                            : new Date().toISOString().split("T")[0]
                    }))
                    : [
                        {
                            amount: row.paidAmount || "",
                            paymentMode: row.paymentMode || "",
                            note: row.paymentNote || "",
                            date: row.paymentDate
                                ? new Date(row.paymentDate.seconds * 1000)
                                    .toISOString()
                                    .split("T")[0]
                                : new Date().toISOString().split("T")[0]
                        },
                        {
                            amount: "",
                            paymentMode: "",
                            note: "",
                            date: new Date().toISOString().split("T")[0]
                        }
                    ]
            );

        } catch (err) {
            console.log(err);
            Swal.fire("Error", "Failed to fetch ticket", "error");
        }
    };

    const fetchTripByChalan = async (ticketNo) => {
        try {
            if (!ticketNo) return;

            const q = query(
                collection(db, "trips"),
                where("challan", "==", ticketNo) // ✅ FIX
            );

            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                Swal.fire("Not Found", "No trip found for this challan", "warning");
                return;
            }

            const docSnap = snapshot.docs[0];

            const row = { id: docSnap.id, ...docSnap.data() };

            console.log("Trip found:", row);

            // ✅ SAME LOGIC AS YOUR onClick
            setSelectedTripId(row.id);

            setFormData({
                customerId: row.customerId || "",
                customerName: row.customerName || "",
                vehicleNo: row.vehicleNo || "",
                product: row.product || "",
                challan: row.challan || "",
                brass: row.brass || "",
                rate: row.rate || 0,
                amount: row.amount || 0,
                mobile: row.mobile || "",
                location: row.location || "",
                wbName: row.wbName || "Matoshri Bridge",
                ticketNo: row.ticketNo || "",
                paymentMode: row.paymentMode || ""
            });

            // ✅ Credit
            if (row.customerId) {
                const cust = customers.find(c => c.id === row.customerId);

                if (cust) {
                    setdailyCreditLimit(cust.dailyCreditLimit || 0);
                    setmonthCreditLimit(cust.monthlyCreditLimit || 0);
                    calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
                } else {
                    calculateCustomerCredit(row.customerId, 0);
                }
            }

            // ✅ Products
            setProductRows(
                row.products?.length > 0
                    ? row.products
                    : [{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]
            );

            // ✅ Weight
            setGrossWeight(row.grossWeight || 0);
            setTareWeight(row.tareWeight || 0);
            setNetWeight(row.netWeight || 0);

            setGrossDate(
                row.grossDate ? row.grossDate.toDate() : null
            );

            setTareDate(
                row.tareDate ? row.tareDate.toDate() : null
            );

            // ✅ Payment
            setPayments(
                row.payments && row.payments.length > 0
                    ? row.payments.map(payment => ({
                        amount: payment.amount || "",
                        paymentMode: payment.mode || "",
                        note: payment.note || "",
                        date: payment.date
                            ? new Date(payment.date.seconds * 1000)
                                .toISOString()
                                .split("T")[0]
                            : new Date().toISOString().split("T")[0]
                    }))
                    : [
                        {
                            amount: row.paidAmount || "",
                            paymentMode: row.paymentMode || "",
                            note: row.paymentNote || "",
                            date: row.paymentDate
                                ? new Date(row.paymentDate.seconds * 1000)
                                    .toISOString()
                                    .split("T")[0]
                                : new Date().toISOString().split("T")[0]
                        },
                        {
                            amount: "",
                            paymentMode: "",
                            note: "",
                            date: new Date().toISOString().split("T")[0]
                        }
                    ]
            );

        } catch (err) {
            console.log(err);
            Swal.fire("Error", "Failed to fetch ticket", "error");
        }
    };


    const sendDeleteOtp = async (mobile) => {
        try {
            const otp = Math.floor(100000 + Math.random() * 900000); // 6 digit
            setGeneratedOtp(otp.toString());

            const phoneid = "1092943420558604";
            const accesstoken = "EAAKj5T0Mx1YBRNd6VhhufPP2ApIjZCsZBFOkl855np9VZBvPvZAZAj7axVAevZBiapxd1Iw38v0hhZBwB2knNeLYSVgjR3RqtPn164H2GQ3ljP46kQvAAq0gsl3lfKDh55ZCsmo5fGZCaUSPpCRqeFjVA6VUeIaiu0ZCNxPPMTsV4oxnnUz4TRoICdbiW0xsAncwZDZD";

            const payload = {
                messaging_product: "whatsapp",
                to: "91" + mobile,
                type: "template",
                template: {
                    name: "delete_trip_otp",
                    language: { code: "en" },
                    components: [
                        {
                            type: "body",
                            parameters: [
                                { type: "text", text: otp } // {{1}}
                            ]
                        },
                        {
                            type: "button",
                            sub_type: "url",
                            index: "0",
                            parameters: [
                                { type: "text", text: otp } // 🔥 REQUIRED for URL
                            ]
                        }
                    ]
                }
            };

            const response = await fetch(`https://graph.facebook.com/v22.0/${phoneid}/messages`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`
                },
                body: JSON.stringify(payload)
            });


            const data = await response.json();
            if (response.ok) {
                console.log("✅ WhatsApp Sent:", data);
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, type: "Otp Whatsapp", status: "Sent", createdAt: Timestamp.now() });
                Toast.fire({ icon: "success", title: "WhatsApp Otp Sent" });
            }
            else {
                console.error("❌ WhatsApp Error:", data);
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, type: "Otp Whatsapp", status: "Failed", error: data.error?.message, createdAt: Timestamp.now() });
            }




            Swal.fire("OTP Sent", "OTP sent on WhatsApp", "success");

        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Failed to send OTP", "error");
        }
    };

    const verifyAndDelete = async () => {
        if (deleteOtp !== generatedOtp) {
            return Swal.fire("Error", "Invalid OTP", "error");
        }

        try {
            await deleteDoc(doc(db, "trips", deleteRowId));

            Swal.fire("Deleted!", "Entry removed successfully", "success");

            setOtpDialogOpen(false);
            setDeleteOtp("");
            setGeneratedOtp("");
            setDeleteRowId(null);

        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Delete failed", "error");
        }
    };

    const customerOptions = useMemo(() => {
        return customers.map(c => ({
            label: c.customerName,
            ...c
        }));
    }, [customers]);

    const handlePrintTicket = async () => {
        if (!formData.ticketNo) {
            return Swal.fire("Error", "Please enter a Ticket Number", "error");
        }

        try {
            const q = query(collection(db, "trips"), where("ticketNo", "==", formData.ticketNo));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                return Swal.fire("Not Found", "No trip found with this Ticket Number", "warning");
            }

            const tripData = querySnapshot.docs[0].data();

            // 1. Set the data to state
            setPrintData(tripData);

            // 2. Small delay to allow React to render the printable component
            setTimeout(() => {
                window.print();
                // 3. Clear after printing (optional)
                setPrintData(null);
            }, 500);

        } catch (error) {
            console.error("Print Error:", error);
            Swal.fire("Error", "Failed to fetch print data", "error");
        }
    };

    const verifyAutoOtp = () => {

        if (autoOtp !== generatedAutoOtp) {
            return Swal.fire("Error", "Invalid OTP", "error");
        }

        // ================= ENABLE =================
        if (pendingAutoAction === "enable") {

            setAutoUnlocked(true);
            setIsAuto(true);

            Swal.fire("Success", "Auto mode enabled", "success");
        }

        // ================= DISABLE =================
        else if (pendingAutoAction === "disable") {

            setIsAuto(false);
            setAutoUnlocked(false);

            Swal.fire("Success", "Auto mode disabled", "success");
        }

        setAutoOtpDialog(false);
        setAutoOtp("");
        setGeneratedAutoOtp("");
        setPendingAutoAction("");
    };

    const sendAutoModeOtp = async (mobile) => {
        try {
            const otp = Math.floor(100000 + Math.random() * 900000);
            setGeneratedAutoOtp(otp.toString());

            const phoneid = "1092943420558604";
            const accesstoken = "EAAKj5T0Mx1YBRNd6VhhufPP2ApIjZCsZBFOkl855np9VZBvPvZAZAj7axVAevZBiapxd1Iw38v0hhZBwB2knNeLYSVgjR3RqtPn164H2GQ3ljP46kQvAAq0gsl3lfKDh55ZCsmo5fGZCaUSPpCRqeFjVA6VUeIaiu0ZCNxPPMTsV4oxnnUz4TRoICdbiW0xsAncwZDZD";

            const payload = {
                messaging_product: "whatsapp",
                to: "91" + mobile,
                type: "template",
                template: {
                    name: "delete_trip_otp",
                    language: { code: "en" },
                    components: [
                        {
                            type: "body",
                            parameters: [
                                { type: "text", text: otp.toString() }
                            ]
                        },
                        {
                            type: "button",
                            sub_type: "url",
                            index: "0",
                            parameters: [
                                { type: "text", text: otp.toString() }
                            ]
                        }
                    ]
                }
            };

            const response = await fetch(
                `https://graph.facebook.com/v22.0/${phoneid}/messages`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesstoken}`
                    },
                    body: JSON.stringify(payload)
                }
            );

            if (response.ok) {
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, type: "Otp Whatsapp", status: "Sent", createdAt: Timestamp.now() });
                Toast.fire({ icon: "success", title: "WhatsApp Otp Sent" });
                setAutoOtpDialog(true);
            }
            else {
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, type: "Otp Whatsapp", status: "Failed", error: "error", createdAt: Timestamp.now() });
            }

            // if (response.ok) {
            //     Swal.fire("OTP Sent", "OTP sent on WhatsApp", "success");
            //     setAutoOtpDialog(true);
            // } else {
            //     Swal.fire("Error", "Failed to send OTP", "error");
            // }

        } catch (err) {
            console.log(err);
            Swal.fire("Error", "OTP send failed", "error");
        }
    };


    return (
        <Box
            sx={{
                bgcolor: '#f4f6f8',
                height: '140vh',        // Takes exactly 100% of the screen height
                overflowY: 'hidden',    // DISABLES VERTICAL SCROLL COMPLETELY
                overflowX: 'hidden',    // Optional: Disables horizontal scroll
                display: 'flex',
                flexDirection: 'column',

                "& .MuiInputBase-root": {
                    fontSize: "14px"
                },

                "& .MuiTableCell-root": {
                    fontSize: "13px",
                    padding: "6px 6px"
                },

                "& .MuiButton-root": {
                    fontSize: "11px",
                    padding: "4px 8px"
                }
                // DELETED: maxHeight: 100 (This was limiting your screen to 100px)
            }}
        >
            {/* Use container prop for MUI Grid instead of className="row" for better spacing */}
            <Grid className="row" sx={{ m: 0, width: '100%' }}>
                {/* LEFT COLUMN */}
                <Grid className="col-sm-3" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper elevation={3} sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            {/* <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={isAuto}
                                        onChange={(e) => {

                                            // ================= ENABLE AUTO =================
                                            if (e.target.checked) {
                                                    setIsAuto(true);
                                                    return;

                                                // SEND OTP FOR ENABLE
                                                // sendAutoModeOtp("7507601020");
                                            }

                                            // ================= DISABLE AUTO =================
                                            else {

                                                // Store action type
                                                setPendingAutoAction("disable");

                                                // Send OTP before disabling
                                                sendAutoModeOtp("7507601020");
                                            }
                                        }}
                                    />
                                }
                                label="Auto"
                            /> */}
                            <FormControlLabel control={<Checkbox size="small" checked={isAuto} onChange={(e) => setIsAuto(e.target.checked)} />} label="Auto" />
                            <Button size="small" onClick={handleConnect}>Connect COM</Button>
                        </Box>

                        <Box sx={{
                            bgcolor: 'black', color: '#ff1744', textAlign: 'center', fontSize: '3.5rem',
                            fontWeight: 'bold', fontFamily: 'monospace', borderRadius: 2, mb: 2, border: '2px solid #333',
                        }}
                        >
                            {isAuto ? liveWeight : (
                                <TextField variant="standard" type="number" value={manualWeight} onChange={(e) => setManualWeight(Number(e.target.value))} inputProps={{ style: { color: '#ff1744', fontSize: '3rem', textAlign: 'center', fontFamily: 'monospace' } }} InputProps={{ disableUnderline: true }} />
                            )}
                        </Box>

                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            onClick={handleCapture}
                            disabled={isCaptured}
                        >
                            Capture {weightType === "tare" ? "Tare" : "Gross"}
                        </Button>


                        <Card sx={{ mb: 1, borderRadius: 2, boxShadow: 4, mt: 1 }}>
                            <CardContent>

                                <Grid className="row" spacing={1} >
                                    <Grid className="col-sm-5 mb-2">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>WB Name</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={formData.wbName} onChange={(e) => setFormData({ ...formData, wbName: e.target.value })} />
                                    </Grid>

                                    <Grid className="col-sm-5">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Ticket No</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={formData.ticketNo}
                                            onChange={(e) =>
                                                setFormData({ ...formData, ticketNo: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    fetchTripByTicket(formData.ticketNo);
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card sx={{ mb: 1, borderRadius: 2, boxShadow: 4 }}>
                            <CardContent>

                                <Grid className="row" spacing={1} >
                                    <Grid className="col-sm-5 mb-2">
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    checked={weightType === "gross"}
                                                    onChange={() => setWeightType("gross")}
                                                />
                                            }
                                            label="Gross "
                                            disabled={grossWeight > 0}

                                        />
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={grossWeight} disabled onChange={(e) => setGrossWeight(Number(e.target.value))} />
                                    </Grid>

                                    <Grid className="col-sm-5 mb-2">
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    checked={weightType === "tare"}
                                                    onChange={() => setWeightType("tare")}
                                                />
                                            }
                                            label="Tare"
                                            disabled={tareWeight > 0}


                                        />
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={tareWeight} disabled onChange={(e) => setTareWeight(Number(e.target.value))} />
                                    </Grid>

                                    <Grid className="col-sm-5 ">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Net Weight</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 ">
                                        <TextField fullWidth size="small" value={netWeight} disabled />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Box display="flex" flexDirection="column" gap={1}>
                            {/* Gross Date Row */}
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                p={1}
                                bgcolor="#e3f2fd"
                                borderRadius={1}
                            >
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                                    Gross Date
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#0d47a1' }}>
                                    {formatDate(grossDate)}
                                </Typography>
                            </Box>

                            {/* Tare Date Row */}
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                p={1}
                                bgcolor="#fce4ec"
                                borderRadius={1}
                            >
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#c2185b' }}>
                                    Tare Date
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#880e4f' }}>
                                    {formatDate(tareDate)}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>

                {/* MIDDLE COLUMN */}
                <Grid className="col-sm-5" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper elevation={3} sx={{ p: 2, flex: 1 }}>
                        {/* <Typography variant="subtitle2" sx={{ mb: 1, bgcolor: '#eee', p: 1 }}>
                            Details Entry
                        </Typography> */}

                        <Box className="row" sx={{ mt: 1, p: 1, bgcolor: "#fff3e0", borderRadius: 1, mb: 1 }}>
                            <Typography className='col-sm-3' fontSize={11}>
                                Daily Credit : ₹ {dailyCreditLimit}
                            </Typography>

                            <Typography className='col-sm-3' fontSize={11}>
                                Monthly Credit : ₹ {monthcreditLimit}
                            </Typography>

                            <Typography className='col-sm-3' fontSize={11}>
                                Used Credit : ₹ {usedCredit}
                            </Typography>

                            <Typography className='col-sm-3' fontSize={11}
                                sx={{
                                    color: remainingCredit < 0 ? "red" : "green",
                                    fontWeight: "bold"
                                }}
                            >
                                Remaining  : ₹ {remainingCredit}
                            </Typography>
                        </Box>

                        <Grid className="row" spacing={1}>

                            {/* Customer */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Customer</Typography>
                            </Grid>


                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <Autocomplete
                                    freeSolo
                                    size="small"
                                    key={resetKey} // Used to force-clear the component after handleProcess
                                    options={customerOptions}

                                    // Logic to handle both object options and manual typing
                                    value={
                                        customerOptions.find(c => c.customerName === formData.customerName) ||
                                        formData.customerName ||
                                        null
                                    }

                                    getOptionLabel={(option) => {
                                        if (typeof option === "string") return option;
                                        return option.customerName || "";
                                    }}

                                    // STRICT FILTER: Only shows names starting with the typed letter
                                    filterOptions={(options, { inputValue }) => {
                                        const search = inputValue.toLowerCase().trim();
                                        if (!search) return options;
                                        return options.filter((opt) => {
                                            const name = (opt.customerName || "").toString().toLowerCase().trim();
                                            return name.startsWith(search);
                                        });
                                    }}

                                    // When a user selects from the dropdown
                                    onChange={(e, val) => {
                                        if (val && typeof val !== "string") {
                                            handlePartySelect(val);
                                        } else if (typeof val === "string") {
                                            setFormData(prev => ({ ...prev, customerName: val.toUpperCase() }));
                                        } else {
                                            setFormData(prev => ({ ...prev, customerName: "" }));
                                        }
                                    }}

                                    // When a user is typing manually
                                    onInputChange={(e, val, reason) => {
                                        if (reason === "input") {
                                            setFormData(prev => ({ ...prev, customerName: val.toUpperCase() }));
                                        }
                                    }}

                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Customer Name"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Vehicle No</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <Autocomplete
                                    freeSolo
                                    size="small"
                                    options={vehicles}
                                    value={formData.vehicleNo || ""}
                                    onChange={(e, val) => {
                                        setFormData({ ...formData, vehicleNo: val || "" });
                                        // if (val) fetchCustomerFromVehicle(val);
                                    }}
                                    onInputChange={(e, val) => setFormData({ ...formData, vehicleNo: val })}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </Grid>



                            {/* Product */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Product</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <Autocomplete
                                    size="small"
                                    options={products.map(p => p.name)}
                                    value={productRows[0]?.productName || ""}
                                    onChange={(e, val) => handleProductChange(0, val)}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </Grid>

                            {/* Challan */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Challan</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={formData.challan}
                                    onChange={(e) => setFormData({ ...formData, challan: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            fetchTripByChalan(formData.challan);
                                        }
                                    }}
                                />
                            </Grid>

                            {/* Brass / Qty */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Brass</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    type="number"
                                    fullWidth
                                    value={productRows[0]?.qty}
                                    onChange={(e) => handleRowChange(0, "qty", e.target.value)}
                                />
                            </Grid>

                            {/* Rate */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Rate</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    type="number"
                                    fullWidth
                                    value={productRows[0]?.rate}
                                    onChange={(e) => handleRowChange(0, "rate", e.target.value)}
                                />
                            </Grid>

                            {/* Amount */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Amount</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    disabled
                                    value={productRows[0]?.amount}
                                />
                            </Grid>

                            {/* Mobile */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Mobile</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={formData.mobile}
                                    onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                                />
                            </Grid>

                            {/* Location */}
                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Location</Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={formData.location}
                                    onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                                />
                            </Grid>


                            <Grid className="col-sm-4" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>
                                    Through
                                </Typography>
                            </Grid>

                            <Grid className="col-sm-8" sx={{ mb: 1 }}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    value={formData.throughId || ""}
                                    onChange={(e) => {
                                        const selected = throughDetails.find(
                                            item => item.id === e.target.value
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            throughId: selected?.id || "",
                                            throughName: selected?.name || ""
                                        }));
                                    }}
                                >
                                    <MenuItem value="">
                                        Select Through
                                    </MenuItem>

                                    {throughDetails.map((item) => (
                                        <MenuItem
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>



                        </Grid>

                        {productRows.slice(1).map((row, index) => {
                            const actualIndex = index + 1;

                            return (
                                <Box
                                    key={actualIndex}
                                    sx={{
                                        border: "1px solid #ddd",
                                        p: 1,
                                        borderRadius: 1,
                                        mt: 1,
                                        position: "relative",
                                    }}
                                >
                                    {/* DELETE BUTTON */}
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() => handleDeleteProduct(actualIndex)}
                                        sx={{
                                            position: "absolute",
                                            top: 4,
                                            right: 4,
                                            zIndex: 2,
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>

                                    <Typography
                                        fontWeight="bold"
                                        sx={{ pr: 5 }}
                                    >
                                        {row.productName || "Product"}
                                    </Typography>

                                    <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                        <Grid item xs={4}>
                                            Qty : {row.qty}
                                        </Grid>

                                        <Grid item xs={4}>
                                            Rate : ₹{row.rate}
                                        </Grid>

                                        <Grid item xs={4}>
                                            Amount : ₹{row.amount}
                                        </Grid>
                                    </Grid>
                                </Box>
                            );
                        })}

                        <Box mt={2} p={1} bgcolor="#e8f5e9" borderRadius={1}>
                            <Typography fontWeight="bold" mb={1}>
                                Payment Details
                            </Typography>

                            {payments.map((payment, index) => (
                                <Grid className="row" spacing={1} key={index} sx={{ mb: 1 }}>
                                    <Grid className="col-sm-4">
                                        <TextField
                                            label={`Amount ${index + 1}`}
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={payment.amount}
                                            onChange={(e) => {
                                                const updated = [...payments];
                                                updated[index].amount = e.target.value;
                                                setPayments(updated);
                                            }}
                                        />
                                    </Grid>

                                    <Grid className="col-sm-4">
                                        <TextField
                                            select
                                            label="Payment Mode"
                                            size="small"
                                            fullWidth
                                            value={payment.paymentMode}
                                            onChange={(e) => {
                                                const updated = [...payments];
                                                updated[index].paymentMode = e.target.value;
                                                setPayments(updated);
                                            }}
                                        >
                                            {paymentModes.map((mode, i) => (
                                                <MenuItem key={i} value={mode}>
                                                    {mode}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid className="col-sm-4">
                                        <TextField
                                            type="date"
                                            size="small"
                                            fullWidth
                                            disabled
                                            value={payment.date}
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                        </Box>

                        <Box display="flex" gap={1} mt={2}>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleProcess}
                                startIcon={<RefreshIcon />}
                                sx={{ flex: 1 }}
                                disabled={monthcreditLimit > 0 && remainingCredit < totalSale}                            >
                                {selectedTripId ? "Update" : "Save "}
                            </Button>

                            <Button
                                variant="contained"
                                color="error"
                                onClick={clearForm}
                                sx={{ flex: 1 }}
                            >
                                <CancelIcon /> Cancel
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={handlePrintTicket} // ✅ Updated
                                sx={{ flex: 1 }}
                            >
                                <PrintIcon sx={{ mr: 1 }} /> Print
                            </Button>
                        </Box>

                        <Box display="flex" justifyContent="space-between" gap={1} mt={2}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setOpenProductDialog(true)}
                            >
                                ➕ Add Product
                            </Button>

                            <Typography sx={{ fontWeight: "bold", fontSize: "24px" }}>
                                Total Sale : ₹ {totalSale}
                            </Typography>


                        </Box>

                    </Paper>
                </Grid>

                <Grid className="col-sm-4" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper
                        elevation={3}
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%" // important
                        }}
                    >
                        {/* HEADER */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} p={1}>
                            <Typography variant="button" color="primary">
                                Pending Transactions
                            </Typography>
                            <IconButton size="small">
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        {/* TABLE SCROLL AREA */}
                        <TableContainer
                            component={Paper}
                            sx={{
                                flex: 1,              // take remaining space
                                overflowY: "auto",    // scroll here
                                mt: 1
                            }}
                        >
                            <Table
                                size="small"
                                stickyHeader
                                sx={{
                                    "& th, & td": {
                                        whiteSpace: "nowrap",
                                        fontSize: 11,        // smaller text
                                        padding: "2px 6px",  // 🔥 reduce padding
                                        lineHeight: 1.2      // 🔥 compact height
                                    }
                                }}
                            >
                                <TableHead>
                                    <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                        <TableCell sx={{ fontWeight: "bold", width: 15 }}>
                                            TKno.
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: "bold", width: 80 }}>
                                            Vehicle No
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: "bold" }}>
                                            WbNo (Weight)
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: "bold" }}>
                                            Date
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {pendingTransactions.length > 0 ? (
                                        pendingTransactions.map((row, index) => {

                                            const isTareDone = row.tareWeight > 0;
                                            const isGrossDone = row.grossWeight > 0;

                                            return (
                                                <TableRow
                                                    key={row.id}
                                                    hover
                                                    sx={{
                                                        cursor: "pointer",
                                                        height: 28,          // 🔥 fixed small height
                                                        "& td": { py: 0.5 }  // 🔥 vertical padding reduce
                                                    }}
                                                    onClick={() => {
                                                        setSelectedTripId(row.id);

                                                        setFormData({
                                                            customerId: row.customerId || "",
                                                            customerName: row.customerName || "",
                                                            vehicleNo: row.vehicleNo || "",
                                                            product: row.product || "",
                                                            challan: row.challan || "",
                                                            brass: row.brass || "",
                                                            rate: row.rate || 0,
                                                            amount: row.amount || 0,
                                                            mobile: row.mobile || "",
                                                            location: row.location || "",
                                                            wbName: row.wbName || "Matoshri Bridge",
                                                            ticketNo: row.ticketNo || "",
                                                            paymentMode: row.paymentMode || "",
                                                            throughId: row.throughId || "",
                                                            throughName: row.throughName || ""
                                                        });

                                                        // CREDIT
                                                        if (row.customerId) {
                                                            const cust = customers.find(c => c.id === row.customerId);
                                                            if (cust) {
                                                                setdailyCreditLimit(cust.dailyCreditLimit || 0);
                                                                setmonthCreditLimit(cust.monthlyCreditLimit || 0);
                                                                calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
                                                            } else {
                                                                calculateCustomerCredit(row.customerId, 0);
                                                            }
                                                        }

                                                        // PRODUCTS
                                                        setProductRows(
                                                            row.products?.length > 0
                                                                ? row.products
                                                                : [{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]
                                                        );

                                                        setTareWeight(row.tareWeight || 0);
                                                        setGrossWeight(row.grossWeight || 0);

                                                        setTareDate(row.tareDate ? row.tareDate.toDate() : null);
                                                        setGrossDate(row.grossDate ? row.grossDate.toDate() : null);

                                                        setPayments(
                                                            row.payments && row.payments.length > 0
                                                                ? row.payments.map(payment => ({
                                                                    amount: payment.amount || "",
                                                                    paymentMode: payment.mode || "",
                                                                    note: payment.note || "",
                                                                    date: payment.date
                                                                        ? new Date(payment.date.seconds * 1000)
                                                                            .toISOString()
                                                                            .split("T")[0]
                                                                        : new Date().toISOString().split("T")[0]
                                                                }))
                                                                : [
                                                                    {
                                                                        amount: row.paidAmount || "",
                                                                        paymentMode: row.paymentMode || "",
                                                                        note: row.paymentNote || "",
                                                                        date: row.paymentDate
                                                                            ? new Date(row.paymentDate.seconds * 1000)
                                                                                .toISOString()
                                                                                .split("T")[0]
                                                                            : new Date().toISOString().split("T")[0]
                                                                    },
                                                                    {
                                                                        amount: "",
                                                                        paymentMode: "",
                                                                        note: "",
                                                                        date: new Date().toISOString().split("T")[0]
                                                                    }
                                                                ]
                                                        );
                                                        const isTareDone = row.tareWeight > 0;
                                                        const isGrossDone = row.grossWeight > 0;

                                                        setSelectedTripId(row.id);

                                                        setTimeout(() => {
                                                            if (isTareDone && !isGrossDone) {
                                                                setWeightType("gross"); // Assuming you have a state for the active radio
                                                                grossRadioRef.current?.focus();
                                                            } else if (!isTareDone && isGrossDone) {
                                                                setWeightType("tare");
                                                                tareRadioRef.current?.focus();
                                                            }
                                                        }, 100); // Small timeout ensures the form state updates before focusing
                                                    }}
                                                >
                                                    {/* Ticket */}
                                                    <TableCell>
                                                        {row.ticketNo || index + 1}
                                                        {/* {row.ticketNo || index + 1} */}
                                                    </TableCell>

                                                    {/* Vehicle */}
                                                    <TableCell sx={{ color: "primary.main" }}>
                                                        <Text style={{ fontWeight: 600, display: 'block' }}>{row.vehicleNo}</Text>
                                                    </TableCell>
                                                    {/* 🔥 WEIGHT DISPLAY */}
                                                    <TableCell>
                                                        {isTareDone && !isGrossDone && (
                                                            <Typography variant="body2">
                                                                Tare: <strong>{row.tareWeight} kg</strong>
                                                            </Typography>
                                                        )}

                                                        {!isTareDone && isGrossDone && (
                                                            <Typography variant="body2">
                                                                Gross: <strong>{row.grossWeight} kg</strong>
                                                            </Typography>
                                                        )}

                                                        {isTareDone && isGrossDone && (
                                                            <Typography variant="body2" color="green">
                                                                Both Added
                                                            </Typography>
                                                        )}
                                                    </TableCell>

                                                    {/* 🔥 DATE DISPLAY */}
                                                    <TableCell>
                                                        {isTareDone && !isGrossDone && row.tareDate
                                                            ? formatDate(row.tareDate.toDate())
                                                            : !isTareDone && isGrossDone && row.grossDate
                                                                ? formatDate(row.grossDate.toDate())
                                                                : "N/A"}
                                                    </TableCell>

                                                    {/* 🔥 DELETE BUTTON */}
                                                    <TableCell>
                                                        <IconButton
                                                            color="error"
                                                            size="small"
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                setDeleteRowId(row.id);
                                                                await sendDeleteOtp('7507601020');
                                                                setOtpDialogOpen(true);
                                                            }}
                                                        >
                                                            🗑️
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                                                <Typography color="text.secondary">
                                                    No pending transactions found.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
                <Box className="row" mt={2}>
                    <video className='col-sm-4' ref={videoRef1} autoPlay playsInline muted />
                    <video className='col-sm-4' ref={videoRef2} autoPlay playsInline muted />
                    <video className='col-sm-4' ref={videoRef3} autoPlay playsInline muted />
                </Box>
            </Grid>

            <Dialog open={openProductDialog} onClose={() => setOpenProductDialog(false)} fullWidth maxWidth="xs">
                <DialogTitle>Add Product</DialogTitle>
                <DialogContent>
                    {/* Product Selection */}
                    <Autocomplete
                        size="small"
                        sx={{ mt: 1 }}
                        options={products.map(p => p.name)}
                        value={tempProduct.productName || ""}
                        onChange={(e, v) => handlePopupProduct(v)}
                        renderInput={(params) => <TextField {...params} label="Product" />}
                    />

                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <TextField
                            label="Qty"
                            size="small"
                            type="number"
                            value={tempProduct.qty}
                            onChange={(e) => handleTempChange("qty", e.target.value)}
                        />
                        <TextField
                            label="Rate"
                            size="small"
                            type="number"
                            value={tempProduct.rate}
                            onChange={(e) => handleTempChange("rate", e.target.value)}
                        />
                    </Box>

                    {/* --- EXTRA CHARGE SECTION --- */}
                    <Typography variant="caption" sx={{ display: 'block', mt: 2, color: 'text.secondary', fontWeight: 'bold' }}>
                        ADDITIONAL CHARGES (Optional)
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                        <TextField
                            label="Charge Label (e.g. Loading)"
                            size="small"
                            fullWidth
                            value={tempProduct.extraLabel || ""}
                            onChange={(e) => handleTempChange("extraLabel", e.target.value)}
                        />
                        <TextField
                            label="Amount"
                            size="small"
                            type="number"
                            sx={{ width: '150px' }}
                            value={tempProduct.extraAmount || 0}
                            onChange={(e) => handleTempChange("extraAmount", e.target.value)}
                        />
                    </Box>

                    {/* Final Total Amount */}
                    <TextField
                        fullWidth size='small'
                        label="Total Amount"
                        type="number"
                        sx={{ mt: 3, bgcolor: '#f0f7ff' }}
                        value={tempProduct.amount}
                        disabled
                        InputProps={{
                            startAdornment: <Typography sx={{ mr: 1, fontWeight: 'bold' }}>₹</Typography>,
                        }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenProductDialog(false)}>Cancel</Button>
                    <Button variant="contained" onClick={addProductFromPopup}>Add Product</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
                <DialogTitle>Enter OTP</DialogTitle>

                <DialogContent>
                    <TextField
                        fullWidth
                        label="Enter OTP"
                        value={deleteOtp}
                        onChange={(e) => setDeleteOtp(e.target.value)}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOtpDialogOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={verifyAndDelete}>
                        Verify & Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={autoOtpDialog} onClose={() => setAutoOtpDialog(false)}>
                <DialogTitle>Enter OTP</DialogTitle>

                <DialogContent>
                    <TextField
                        fullWidth
                        label="OTP"
                        value={autoOtp}
                        onChange={(e) => setAutoOtp(e.target.value)}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setAutoOtpDialog(false)}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={verifyAutoOtp}
                    >
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>

            <div id="a4-print-wrap">
                {printData && (
                    <div className="a4-receipt">
                        {/* CENTERED HEADER SECTION */}
                        <div className="header-modern-centered">
                            <h1>MATOSHRI INFRA<span className="highlight"> DHARASHIV PVT LTD</span></h1>
                            <p className="subtitle">Dharashiv, Maharashtra | Mo. +91 75076 01020</p>
                        </div>

                        {/* TICKET & DATE BAR (Top of Details) */}
                        <div className="ticket-bar">
                            <div className="bar-item">
                                <strong>TICKET NO:</strong> #{printData.ticketNo} <br />
                                <strong>Chalan NO:</strong> #{printData.challan}
                            </div>
                            <div className="bar-item">
                                <strong>DATE:</strong> {printData.grossDate?.toDate().toLocaleDateString()}
                            </div>
                        </div>

                        {/* CUSTOMER & VEHICLE INFO */}
                        <div className="info-grid">
                            <div className="info-card">
                                <label>CUSTOMER DETAILS</label>
                                <p><strong>{printData.customerName}</strong></p>
                                <p>{printData.mobile || "N/A"}</p>
                            </div>
                            <div className="info-card">
                                <label>VEHICLE DETAILS</label>
                                <p><strong>{printData.vehicleNo}</strong></p>
                                <p>{printData.wbName || "Matoshri Bridge"}</p>
                            </div>
                            <div className="info-card">
                                <label>WEIGHT SUMMARY</label>
                                <div className="weight-row"><span>Gross:</span> <b>{printData.grossWeight} kg</b></div>
                                <div className="weight-row"><span>Tare:</span> <b>{printData.tareWeight} kg</b></div>
                                <div className="weight-row net"><span>Net Weight:</span> <b>{printData.netWeight} kg</b></div>
                            </div>
                        </div>

                        {/* PRODUCT TABLE */}
                        <table className="modern-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th style={{ textAlign: 'left' }}>Product Description</th>
                                    <th>Qty / Brass</th>
                                    <th>Rate (₹)</th>
                                    <th>Total (₹)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {printData.products?.map((p, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td style={{ textAlign: 'left' }}>{p.productName}</td>
                                        <td>{p.qty || p.brass || 0}</td>
                                        <td>{Number(p.rate).toLocaleString("en-IN")}</td>
                                        <td>{Number(p.amount).toLocaleString("en-IN")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="grand-total-container">
                            <div className="total-label">GRAND TOTAL</div>
                            <div className="total-amount">₹ {Number(printData.totalAmount || 0).toLocaleString("en-IN")}</div>
                        </div>

                        {/* HIGHLIGHTED IMAGE SECTION */}
                        <div className="photo-evidence-section">
                            <h3 className="section-title">WEIGHMENT EVIDENCE (CAM PHOTOS)</h3>
                            <div className="photo-grid">
                                {printData.tarePhotos?.map((img, idx) => (
                                    <div className="photo-box" key={`tare-${idx}`}>
                                        <img src={img} alt="Tare" />
                                        <span>TARE - CAM {idx + 1}</span>
                                    </div>
                                ))}
                                {printData.grossPhotos?.map((img, idx) => (
                                    <div className="photo-box" key={`gross-${idx}`}>
                                        <img src={img} alt="Gross" />
                                        <span>GROSS - CAM {idx + 1}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="sign-bar">
                            <div className="bar-item">
                                <strong>Receiver Signature</strong>
                            </div>
                            <div className="bar-item">
                                <strong>Matohshi Infra Dharashiv Pvt.Ltd</strong>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
#a4-print-wrap { display: none; }

@media print {

  @page {
    size: A4;
    margin: 0;
  }

  html, body {
    width: 1005px;
    margin: 0 !important;
    background: #fff;
  }

  body * {
    visibility: hidden;
  }

  #a4-print-wrap, 
  #a4-print-wrap * {
    visibility: visible;
  }

  #a4-print-wrap { 
    display: block !important; 
    position: absolute;
    top: 0; 
    left: 0; 
    width: 1005px;
  }

  .a4-receipt {
    width: 1005px;
    height: auto;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden; /* 🔥 critical for single page */
    font-family: 'Segoe UI', Roboto, sans-serif;
    color: #333;
  }

  /* Centered Header */
  .header-modern-centered {
    text-align: center;
    border-bottom: 2px solid #1a237e;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .header-modern-centered h1 { margin: 0; font-size: 28px; color: #1a237e; }
  .highlight { color: #ffab00; }
  .subtitle { margin: 5px 0 0; color: #666; font-size: 16px; }

  /* Ticket Bar above details */
  .ticket-bar {
    display: flex;
    justify-content: space-between;
    background: #f5f5f5 !important;
    padding: 10px 15px;
    border-radius: 6px;
    margin-bottom: 15px;
    border: 1px solid #ddd;
    font-size: 17px;
  }

  .sign-bar {
    display: flex;
    justify-content: space-between;
    padding: 40px 75px;
    border-radius: 6px;
    margin-bottom: 15px;
    font-size: 17px;
    margin-top:100px;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1.2fr;
    gap: 15px;
    margin-bottom: 20px;
  }

  .info-card {
    padding: 12px;
    background: #fafafa !important;
    border-radius: 8px;
    border-left: 4px solid #1a237e;
  }
  .info-card label { font-size: 15px; font-weight: bold; color: #1a237e; display: block; margin-bottom: 4px; }
  .info-card p { margin: 0; font-size: 17px; }

  .weight-row { display: flex; justify-content: space-between; font-size: 16px; }
  .net { border-top: 1px solid #ddd; margin-top: 5px; padding-top: 5px; color: #d32f2f; font-size: 17px; }

  .modern-table { width: 100%; border-collapse: collapse; }
  .modern-table th { background: #1a237e !important; color: white !important; padding: 10px; font-size: 16px; }
  .modern-table td { padding: 10px; border-bottom: 1px solid #eee; font-size: 16px; text-align: center; }

  .grand-total-container {
    margin-top: 15px;
    padding: 12px 20px;
    background: #1a237e !important;
    color: white !important;
    border-radius: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
  }
  .total-amount { font-size: 20px; font-weight: bold; }

  .photo-evidence-section { margin-top: 20px; page-break-inside: avoid; }
  .section-title { font-size: 14px; color: #1a237e; border-bottom: 1px solid #ddd; padding-bottom: 5px; }
  
  .photo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 10px;
  }
  .photo-box img { width: 100%; height: 210px; object-fit: cover; border-radius: 4px; border: 1px solid #ddd; }
  .photo-box span { font-size: 12px; display: block; margin-top: 3px; color: #666; font-weight: bold; }

  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
}
`}</style>

        </Box>
    );
};
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: 'Helvetica',
        fontSize: 10
    },

    headerBox: {
        textAlign: 'center',
        borderBottomWidth: 2,
        borderBottomColor: '#000',
        paddingBottom: 8,
        marginBottom: 10
    },
    company: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    sub: {
        fontSize: 10
    },

    invoiceTitleBox: {
        alignItems: 'center',
        marginVertical: 10
    },
    invoiceTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        borderBottomWidth: 1,
        paddingBottom: 4
    },

    detailsWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12
    },
    detailsCard: {
        width: '48%',
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 6,
        padding: 8
    },
    cardTitle: {
        fontSize: 11,
        fontWeight: 'bold',
        marginBottom: 5,
        borderBottomWidth: 1,
        paddingBottom: 3
    },

    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 4
    },

    label: {
        fontSize: 9,
        color: '#555'
    },
    value: {
        fontSize: 10,
        fontWeight: 'bold'
    },

    tableBox: {
        borderWidth: 1,
        borderColor: '#ccc',
        marginTop: 5
    },

    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f0f0f0',
        padding: 6,
        fontWeight: 'bold',
        borderBottomWidth: 1
    },

    tableRow: {
        flexDirection: 'row',
        padding: 6,
        borderBottomWidth: 0.5,
        borderBottomColor: '#ddd'
    },

    totalSection: {
        marginTop: 10,
        padding: 10,
        borderTopWidth: 2,
        alignItems: 'flex-end'
    },
    totalLabel: {
        fontSize: 11,
        fontWeight: 'bold'
    },
    totalValue: {
        fontSize: 14,
        fontWeight: 'bold'
    },

    footerBox: {
        marginTop: 20,
        alignItems: 'center'
    },
    footer: {
        fontSize: 10,
        color: '#555'
    }
});

export default WeighbridgeSoftware;